import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { MaintenanceWindowPatchManagementVendorProductSelectorWebComponent } from '../component/MaintenanceWindowPatchManagementVendorProductSelectorWebComponent';
import { Column, ColumnKeys, GridRow, VendorProductsPair } from '../types';

export class MaintenanceWindowPatchManagementVendorProductSelectorGridDataProvider extends GridBaseDataProvider<
  Column,
  ColumnKeys
> {
  constructor(private component: MaintenanceWindowPatchManagementVendorProductSelectorWebComponent) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return {
      summary: '',
      numItems: this.component.vendorProductsPairs.length,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: GridRow[] }> {
    return {
      rawEvents: this.component.vendorProductsPairs
        .sort((a: VendorProductsPair, b: VendorProductsPair) => {
          const firstName = a.vendor.name.toLocaleLowerCase();
          const secondName = b.vendor.name.toLocaleLowerCase();

          if (firstName === secondName) {
            return 0;
          }

          return firstName > secondName ? 1 : -1;
        })
        .map(vendorProductPair => {
          return { ...vendorProductPair, actions: true };
        }),
    };
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    throw new Error('Not implemented!');
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    throw new Error('Not implemented!');
  }

  shouldDataReloadOnResetView(): boolean {
    return false;
  }
}
